import {weChatrequest} from '@/utils/request'
 // 全景监测新增
export function addData1(data) {
  return weChatrequest({
    url: '/api/v1/businessDict/panorama/add',
    method: 'post',
    data: data
  })
}
// 全景监测修改
export function updateData1(data) {
  return weChatrequest({
    url: '/api/v1/businessDict/panorama/add',
    method: 'post',
    data: data
  })
}

// 查询全景监测
export function getData1() {
  return weChatrequest({
    url: '/api/v1/businessDict/panorama/latestStats',
    method: 'get'
  })
}
// 管网信息新增
export function addData2(data) {
  return weChatrequest({
    url: '/api/v1/businessDict/gasNetwork/add',
    method: 'post',
    data: data
  })
}
  
// 管网信息新增
export function updateData2(data) {
  return weChatrequest({
    url: '/api/v1/businessDict/gasNetwork/add',
    method: 'post',
    data: data
  })
}
  
// 查询管网信息
export function getData2() {
  return weChatrequest({
    url: '/api/v1/businessDict/gasNetwork/latestStats',
    method: 'get'
  })
}

// 查询基础信息统计
export function getData3() {
  return weChatrequest({
    url: '/api/v1/businessDict/baseInfo/latestStats',
    method: 'get'
  })
}
// 基础信息统计新增
export function addData3(data) {
  return weChatrequest({
    url: '/api/v1/businessDict/baseInfo/add',
    method: 'post',
    data: data
  })
}

// 基础信息统计修改
export function updateData3(data) {
  return weChatrequest({
    url: '/api/v1/businessDict/baseInfo/add',
    method: 'post',
    data: data
  })
}
// 查询用户类型分析
export function getData4() {
  return weChatrequest({
    url: '/api/v1/businessDict/gasCustomer/latestStats',
    method: 'get'
  })
}
// 用户类型分析新增
export function addData4(data) {
  return weChatrequest({
    url: '/api/v1/businessDict/gasCustomer/add',
    method: 'post',
    data: data
  })
}

// 用户类型分析修改
export function updateData4(data) {
  return weChatrequest({
    url: '/api/v1/businessDict/gasCustomer/add',
    method: 'post',
    data: data
  })
}
//最近一周报警趋势
export function getAlarmTrend(params) {
  return weChatrequest({
    url: '/panorama/alarm/trend',
    method: 'get',
    params
  })
}
// 实时告警
export function alarms() {
  return weChatrequest({
    url: `/panorama/alarms`,
    method: "get",
  });
}